(function () {

  'use strict';

  /**
   * @name ute-ui
   * @version 0.9.1
   * @namespace ute-ui
   */

  angular.module('ute.ui.chartist', []);

})();

(function () {

  'use strict';

  /**
   * @author Chester Rivas
   * @description wrapper directive for chartist
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui.chartist')

    /*global Chartist:false */
    .constant('chartist', Chartist)

    .directive('uteChartist', ["$compile", "chartist", "uteLineOptions", "uteBarOptions", "utePieOptions", "$filter", function ($compile, chartist, uteLineOptions, uteBarOptions, utePieOptions, $filter) {

      return {
        restrict: 'EA',
        scope: {
          chartData: '=',
          chartOptions: '=',
          chartResponsiveOptions: '=',
          chartBreakLine: '=',
          chartShowLimitLine: '=',
          chartStyle: '@',
          chartType: '@',
          onCreated: '&',
          onFinishedDrawing: '&',
          onDraw: '&'
        },
        replace: true,
        template: '<div class="ct-chart ute-chart"></div>',
        controller: ["$scope", "$element", function ($scope, $element) {

          $scope.chart = null;
          $scope.chartData = angular.copy($scope.chartData);
          $scope.chartOptions = angular.copy($scope.chartOptions);

          var $target = $element[0],
            options,
            maxValue = 0;

          if ($scope.chartType === 'line') {

            // if chart data is defined and has more than 2 properties: labels and series
            if (angular.isDefined($scope.chartData) && angular.isDefined($scope.chartData.labels) && angular.isDefined($scope.chartData.series)) {

              var findLongestArray = function (listOfArrays) {
                  return _.reduce(listOfArrays, function (memo, num) {
                    var length = angular.isDefined(num.data) ? num.data.length : num.length;
                    return length > memo ? num.data : memo;
                  }, 0);
                },
                seriesArray;

              if ($scope.chartData.series === null || $scope.chartData.series === undefined) {
                console.warn('chartData.series is null');
                return;
              }

              seriesArray = findLongestArray($scope.chartData.series);


              // if chartShowLimitLine is enabled
              if ($scope.chartShowLimitLine && $scope.chartShowLimitLine.enabled) {

                ////////////////////

                if (angular.isDefined($scope.chartShowLimitLine.limit)) {

                  var maxLine;

                  if (Array.isArray($scope.chartShowLimitLine.limit)) {
                    _.each($scope.chartShowLimitLine.limit, function (l, index) {
                      maxLine = [];
                      _.each(seriesArray, function () {
                        maxLine.push(l);
                      });
                      $scope.chartData.series.push({
                        data: maxLine,
                        className: 'ute-limit-line ute-limit-line-' + (index + 1)
                      });
                    });
                  } else if (typeof $scope.chartShowLimitLine.limit === 'number') {
                    maxLine = [];
                    _.each(seriesArray, function () {
                      maxLine.push($scope.chartShowLimitLine.limit);
                    });
                    $scope.chartData.series.push({
                      data: maxLine,
                      className: 'ute-limit-line'
                    });
                  } else {
                    console.warn('limit line is not valid data type');
                  }

                }

              }

              options = _.defaults({}, $scope.chartOptions, uteLineOptions());
              $scope.chart = chartist.Line($target, $scope.chartData, options, $scope.chartResponsiveOptions);

            } else {

              if (!angular.isDefined($scope.chartData)) {
                throw new Error('uteChartist error: $scope.chartData is undefined');
              } else {
                throw new Error('uteChartist error: $scope.chartData is defined but does not have the correct properties: series and labels');
              }

            }

          } else if ($scope.chartType === 'bar') {

            if ($scope.chartStyle === 'usage') {

              // will format a bar chart to have 3 stacked bars on top of each other
              var standarizedBarChartData = [
                [],
                [],
                []
              ];

              if ($scope.chartData.series[0].length !== $scope.chartData.series[1].length) {
                console.warn('series data at [0] and at [1] must be the same length');
              }

              _.each($scope.chartData.series[0], function (seriesData, index) {

                var usageValue,
                  overageValue,
                  underageValue;

                if ($scope.chartData.series[0][index] > maxValue) {
                  maxValue = $scope.chartData.series[0][index];
                }

                if ($scope.chartData.series[1][index] === -1) {

                  // if unlimited
                  usageValue = $scope.chartData.series[0][index];
                  overageValue = 0;
                  underageValue = 0;

                } else if ($scope.chartData.series[0][index] > $scope.chartData.series[1][index]) {

                  // if over the limit
                  usageValue = $scope.chartData.series[1][index];
                  overageValue = $scope.chartData.series[0][index] - $scope.chartData.series[1][index];
                  underageValue = 0;

                } else {

                  // if under the limit
                  usageValue = $scope.chartData.series[0][index];
                  overageValue = 0;
                  underageValue = $scope.chartData.series[1][index] - $scope.chartData.series[0][index];

                }

                standarizedBarChartData[0].push(usageValue);
                standarizedBarChartData[1].push(overageValue);
                standarizedBarChartData[2].push(underageValue);

              });

              $scope.chartData.series = standarizedBarChartData;
              // force the bar chart to be stacked
              $scope.chartOptions.stackBars = true;

            }

            options = _.defaults({}, $scope.chartOptions, uteBarOptions());
            $scope.chart = chartist.Bar($target, $scope.chartData, options, $scope.chartResponsiveOptions);

          } else if ($scope.chartType === 'pie') {

            options = _.defaults({}, $scope.chartOptions, utePieOptions());
            $scope.chart = chartist.Pie($target, $scope.chartData, options, $scope.chartResponsiveOptions);

          } else {

            throw new Error('uteChartist error: unknown chartType, must be \'line\', \'bar\' or \'pie\'');

          }

          var drawComplete = false;

          // CREATED
          $scope.chart.on('created', function () {

            $($element).find('svg').css({
              overflow: 'visible'
            });

            // draw limit line badge
            if ($scope.chartShowLimitLine && $scope.chartShowLimitLine.limit && $scope.chartShowLimitLine.enabled) {

              var limitFiltered = $filter('uteCapacity')($scope.chartShowLimitLine.limit);
              var message = $filter('translate')('global.label.dataLimit');
              var $limitLine = $($element).find('.ute-limit-line');
              var d = $limitLine.find('path').attr('d');
              var yPos = d.split(',')[1].split('L')[0] - 25;
              var groupMarkup = '<g>' +
                '<rect x="' + 50 + '" y="' + yPos + '" fill="#ffffff" width="60" height="50" />' +
                '<text class="ute-ct-badge" x="0" y="' + yPos + '">' +
                '<tspan text-anchor="middle" x="80" y="' + (yPos + 20) + '">' + limitFiltered + '</tspan>' +
                '<tspan text-anchor="middle" x="80" y="' + (yPos + 20) + '" dy="15">' + message + '</tspan>' +
                '</text>' +
                '</g>';

              $element.find('svg').append(groupMarkup);
              $element.find('svg').html($element.find('svg').html());

            }

            // draw bar overage labels
            if ($scope.chartStyle === 'usage') {

              $($element).css({
                position: 'relative'
              });

              //$($element).find('.bar-overage').remove();
              //$($element).find('.bar-underage').remove();

              _.each($scope.chartData.series[1], function (data, index) {

                var childIndex = index + 1,
                  overData = $scope.chartData.series[1][index],
                  usageData = $scope.chartData.series[0][index] + $scope.chartData.series[2][index],
                  overDataFiltered = $filter('uteCapacity')(overData),
                  usageDataFiltered = $filter('uteCapacity')(usageData),
                  overTranslated = $filter('translate')('global.label.over').toLowerCase(),
                  underTranslated = $filter('translate')('global.label.limit').toLowerCase(),
                  unlimitedTranslated = $filter('translate')('global.label.unlimited').toLowerCase(),
                  $currentALineElement = $($element).find('.ct-series-a line:nth-child(' + childIndex + ')'),
                  $currentBLineElement = $($element).find('.ct-series-b line:nth-child(' + childIndex + ')'),
                  $currentCLineElement = $($element).find('.ct-series-c line:nth-child(' + childIndex + ')'),
                  aBarXPos = Number($currentALineElement.attr('x1')),
                  aBarYPos = Number($currentALineElement.attr('y2')) - 20,
                  bBarXPos = Number($currentBLineElement.attr('x1')),
                  bBarYPos = Number($currentBLineElement.attr('y2')) - 20,
                  cBarXPos = Number($currentCLineElement.attr('x1')),
                  cBarYPos = Number($currentCLineElement.attr('y2')) - 20,
                  textOverMarkup = '<text class="bar-overage" x="' + bBarXPos + '" y="' + bBarYPos + '">' +
                    '<tspan x="' + bBarXPos + '" text-anchor="middle">' + overDataFiltered + '</tspan>' +
                    '<tspan x="' + bBarXPos + '" text-anchor="middle" dy="15">' + overTranslated + '</tspan>' +
                    '</text>',
                  textUnderMarkup = '<text class="bar-underage" x="' + cBarXPos + '" y="' + cBarYPos + '">' +
                    '<tspan x="' + cBarXPos + '" text-anchor="middle">' + usageDataFiltered + '</tspan>' +
                    '<tspan x="' + cBarXPos + '" text-anchor="middle" dy="15">' + underTranslated + '</tspan>' +
                    '</text>',
                  textUnlimitedMarkup = '<text class="bar-unlimited" x="' + aBarXPos + '" y="' + aBarYPos + '">' +
                    '<tspan x="' + aBarXPos + '" text-anchor="middle" dy="15">' + unlimitedTranslated + '</tspan>' +
                    '</text>';

                if ($scope.chartData.series[1][index] === 0 && $scope.chartData.series[2][index] === 0) {

                  $($element).find('svg').append(textUnlimitedMarkup);

                } else if ($scope.chartData.series[1][index] === 0) {

                  $($element).find('svg').append(textUnderMarkup);

                } else if ($scope.chartData.series[2][index] === 0) {

                  $($element).find('svg').append(textOverMarkup);

                }


              });

              $element.find('svg').html($element.find('svg').html());

            }

            // if $scope.onCreated is defined then fire method
            if (angular.isDefined($scope.onCreated)) {
              var expressionHandler = $scope.onCreated();
              if (typeof expressionHandler === 'function') {
                expressionHandler($scope.chart);
              }
            }

            drawComplete = true;
            $scope.chart.eventEmitter.emit('finishedDrawing');

          });

          // DRAWING
          $scope.chart.on('draw', function (drawData) {
            // if $scope.onDraw is defined then fire method
            if (angular.isDefined($scope.onDraw)) {
              var expressionHandler = $scope.onDraw();
              if (typeof expressionHandler === 'function') {
                expressionHandler(drawData);
              }
            }
          });

          // FINISHED DRAWING
          $scope.chart.on('finishedDrawing', function () {
            $element.find('svg').html($element.find('svg').html());
            if (angular.isDefined($scope.onFinishedDrawing)) {
              var expressionHandler = $scope.onFinishedDrawing();
              if (typeof expressionHandler === 'function') {
                expressionHandler();
              }
            }
          });

        }]

      };

    }]);

})();

(function () {

  'use strict';

  /**
   * @author Chester Rivas
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui.chartist')

    .constant('uteBarOptions', function (chartist) {

      var defaultOptions = {
        // Options for X-Axis
        axisX: {
          // The offset of the chart drawing area to the border of the container
          offset: 30,
          // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
          position: 'end',
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true,
          // This value specifies the minimum width in pixel of the scale steps
          scaleMinSpace: 30,
          // Use only integer values (whole numbers) for the scale steps
          onlyInteger: false
        },
        // Options for Y-Axis
        axisY: {
          // The offset of the chart drawing area to the border of the container
          offset: 40,
          // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
          position: 'start',
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true,
          // This value specifies the minimum height in pixel of the scale steps
          scaleMinSpace: 20,
          // Use only integer values (whole numbers) for the scale steps
          onlyInteger: false
        },
        // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
        width: undefined,
        // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
        height: undefined,
        // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
        high: undefined,
        // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
        low: undefined,
        // Use only integer values (whole numbers) for the scale steps
        onlyInteger: false,
        // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
        chartPadding: {
          top: 15,
          right: 15,
          bottom: 5,
          left: 10
        },
        // Specify the distance in pixel of bars in a group
        seriesBarDistance: 15,
        // If set to true this property will cause the series bars to be stacked and form a total for each series point. This will also influence the y-axis and the overall bounds of the chart. In stacked mode the seriesBarDistance property will have no effect.
        stackBars: false,
        // Inverts the axes of the bar chart in order to draw a horizontal bar chart. Be aware that you also need to invert your axis settings as the Y Axis will now display the labels and the X Axis the values.
        horizontalBars: false,
        // If set to true then each bar will represent a series and the data array is expected to be a one dimensional array of data values rather than a series array of series. This is useful if the bar chart should represent a profile rather than some data over time.
        distributeSeries: false,
        // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
        reverseData: false,
        // Override the class names that get used to generate the SVG structure of the chart
        classNames: {
          chart: 'ct-chart-bar',
          horizontalBars: 'ct-horizontal-bars',
          label: 'ct-label',
          labelGroup: 'ct-labels',
          series: 'ct-series',
          bar: 'ct-bar',
          grid: 'ct-grid',
          gridGroup: 'ct-grids',
          vertical: 'ct-vertical',
          horizontal: 'ct-horizontal',
          start: 'ct-start',
          end: 'ct-end'
        }
      };

      return defaultOptions;

    });

})();

(function () {

  'use strict';

  /**
   * @author Chester Rivas
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui.chartist')

    .constant('uteLineOptions', function (chartist) {

      return {
        // Options for X-Axis
        axisX: {
          // The offset of the labels to the chart area
          offset: 30,
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true
        },
        // Options for Y-Axis
        axisY: {
          // The offset of the labels to the chart area
          offset: 40,
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true,
          // This value specifies the minimum height in pixel of the scale steps
          scaleMinSpace: 20
        },
        // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
        width: undefined,
        // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
        height: undefined,
        // If the line should be drawn or not
        showLine: true,
        // If dots should be drawn or not
        showPoint: true,
        // If the line chart should draw an area
        showArea: false,
        // The base for the area chart that will be used to close the area shape (is normally 0)
        areaBase: 0,
        // If the line will stop drawing when the data ends rather than normalizing. This will not manipulate data with multiple length.
        allowVariableDataLengths: false,
        // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions availabel in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
        lineSmooth: true,
        // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
        low: undefined,
        // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
        high: undefined,
        // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
        chartPadding: 5,
        // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full availabel width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
        fullWidth: false,
        // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
        reverseData: false
      };

    });

})();

(function () {

  'use strict';

  /**
   * @author Chester Rivas
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui.chartist')

    .constant('utePieOptions', function (chartist) {

      return {
        // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
        width: undefined,
        // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
        height: undefined,
        // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
        chartPadding: 5,
        // Override the class names that get used to generate the SVG structure of the chart
        classNames: {
          chart: 'ute-ct-chart-pie',
          series: 'ute-ct-series ct-series',
          slice: 'ute-ct-slice ct-slice',
          donut: 'ute-ct-donut ct-donut',
          label: 'ute-ct-label ct-label'
        },
        // The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
        startAngle: 0,
        // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
        total: undefined,
        // If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
        donut: false,
        // Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
        donutWidth: 60,
        // If a label should be shown or not
        showLabel: true,
        // Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
        labelOffset: 0,
        // Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
        labelDirection: 'neutral',
        // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
        reverseData: false
      };

    });

})();

/**
 * Chartist.js plugin to display a data label on top of the points in a line chart.
 *
 */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  var defaultOptions = {
    threshold: 0,
    classNames: {
      aboveThreshold: 'ct-threshold-above',
      belowThreshold: 'ct-threshold-below'
    },
    maskNames: {
      aboveThreshold: 'ct-threshold-mask-above',
      belowThreshold: 'ct-threshold-mask-below'
    }
  };

  function createMasks(data, options) {
    // Select the defs element within the chart or create a new one
    var defs = data.svg.querySelector('defs') || data.svg.elem('defs');
    // Project the threshold value on the chart Y axis
    var projectedThreshold = data.chartRect.height() - data.axisY.projectValue(options.threshold) + data.chartRect.y2;
    var width = data.svg.width();
    var height = data.svg.height();

    // Create mask for upper part above threshold
    defs
      .elem('mask', {
        x: 0,
        y: 0,
        width: width,
        height: height,
        id: options.maskNames.aboveThreshold
      })
      .elem('rect', {
        x: 0,
        y: 0,
        width: width,
        height: projectedThreshold,
        fill: 'white'
      });

    // Create mask for lower part below threshold
    defs
      .elem('mask', {
        x: 0,
        y: 0,
        width: width,
        height: height,
        id: options.maskNames.belowThreshold
      })
      .elem('rect', {
        x: 0,
        y: projectedThreshold,
        width: width,
        height: height - projectedThreshold,
        fill: 'white'
      });

    return defs;
  }

  Chartist.plugins = Chartist.plugins || {};
  Chartist.plugins.ctThreshold = function (options) {

    options = Chartist.extend({}, defaultOptions, options);

    return function ctThreshold(chart) {
      if (chart instanceof Chartist.Line || chart instanceof Chartist.Bar) {
        chart.on('draw', function (data) {
          if (data.type === 'point') {
            // For points we can just use the data value and compare against the threshold in order to determine
            // the appropriate class
            data.element.addClass(
              data.value.y >= options.threshold ? options.classNames.aboveThreshold : options.classNames.belowThreshold
            );
          } else if (data.type === 'line' || data.type === 'bar' || data.type === 'area') {

            if (!data.series.className || (data.series.className && options.ignoreClass.indexOf(data.series.className) === -1)) {

              //console.log('---------------------------------');
              //console.log('plugin draw masks:', chart);
              //console.log('---------------------------------');

              // Cloning the original line path, mask it with the upper mask rect above the threshold and add the
              // class for above threshold
              data.element
                .parent()
                .elem(data.element._node.cloneNode(true))
                .attr({
                  mask: 'url(#' + options.maskNames.aboveThreshold + ')'
                })
                .addClass(options.classNames.aboveThreshold);

              // Use the original line path, mask it with the lower mask rect below the threshold and add the class
              // for blow threshold
              data.element
                .attr({
                  mask: 'url(#' + options.maskNames.belowThreshold + ')'
                })
                .addClass(options.classNames.belowThreshold);

            }
          }
        });

        // On the created event, create the two mask definitions used to mask the line graphs
        chart.on('created', function (data) {
          createMasks(data, options);
        });
      }
    };
  };
}(window, document, Chartist));

